<template>
  <div class="carAftherMarket">
    <div class="slide-one"></div>
    <div class="content-center" style="padding: 40px 0 80px">
      <div class="title-box">
        <div class="title">购车司机专享贴心服务与超值福利</div>
      </div>
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/afther-1.png" alt="" />
            <div class="title">加油充电</div>
            <div class="p">立减、满减、折扣，优惠多多</div>
          </div></el-col
        >
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/afther-2.png" alt="" />
            <div class="title">车辆服务</div>
            <div class="p">保养、ETC、违章查询代办</div>
          </div></el-col
        >
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/afther-3.png" alt="" />
            <div class="title">通讯服务</div>
            <div class="p">WIFI设备、电话卡</div>
          </div></el-col
        >
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/afther-4.png" alt="" />
            <div class="title">生活服务</div>
            <div class="p">社保代缴、电影票</div>
          </div></el-col
        >
      </el-row>
    </div>
    <div class="slide-two">
      <div style="overflow: hidden">
        <div class="title-box" style="margin-top:70px">
          <div class="title">货拉拉商城——面向货运司机的车辆生活购物平台</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.content-center {
  width: 1080px;
  margin: 0 auto;
  padding: 10px 50px;
}
.slide-one {
  height: 520px;
  background: url(../assets/aftherMarket.png) no-repeat center;
  background-size: auto 100%;
  position: relative;
}
.slide-two {
  height: 809px;
  // margin: 36px 0 128px;
  background: url(../assets/aftherLive.png) no-repeat center;
  background-size: auto 100%;
}
.row-bg{
  margin-top: 30px;
}
.card-square:hover {
  box-shadow: 0px 0px 10px 5px #e3e3e3;
}
.card-square {
  text-align: center;
  height: 225px;
  cursor: pointer;
  transition: all 0.5s linear;
  // box-shadow: #e3e3e3 10px 16px 2px -9px;

  img {
    width: 68px;
    height: 68px;
    margin: 40px 0 10px 0;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    color: #2f3439;
  }
  .p {
    font-size: 12px;
    color: #768191;
  }
}
.title-box::before {
  content: "";
  display: block;
  position: absolute;
  background: #f16622;
  width: 85px;
  height: 2px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.title-box {
  position: relative;
  text-align: center;
  height: 66px;
  .title {
    font-size: 30px;
    font-weight: 600;
    color: #2f3439;
    line-height: 66px;
  }
}
</style>